export const INFRA_SET_ATTRIBUTE = 'infraSetAttribute';
export const INFRA_PUSH_TO_ARRAY = 'infraAddToArray';
export const INFRA_CONCAT_ARRAY = 'infraConcatToArray';
export const INFRA_CLEAR_ARRAY = 'infraClearArray';
export const INFRA_ADD_TO_ARRAY_BY_POSITION = 'infraAddToArrayByPosition';
export const INFRA_RESET_STATE = 'infraResetState';
export const SET_VALUE = 'setValue';
